export default __webpack_public_path__ + "static/media/scratch-intermediate.229df902.png";